function OrderSummary({ 
  title, 
  category, 
  duration, 
  price, 
  imageCount = null, 
  type = 'article',
  timeRemaining = null 
}) {
  const typeLabels = {
    'article': 'Article',
    'video': 'Vidéo',
    'banner': 'Bannière publicitaire'
  }

  return (
    <div className="bg-gradient-to-br from-[#001F3F] to-[#003366] rounded-2xl p-6 text-white shadow-xl">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-bold">Récapitulatif</h3>
        {timeRemaining && timeRemaining !== 'Expiré' && (
          <div className="px-3 py-1.5 bg-white/20 rounded-full backdrop-blur-sm">
            <div className="flex items-center gap-2">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="text-sm font-semibold">{timeRemaining}</span>
            </div>
          </div>
        )}
      </div>

      <div className="space-y-4">
        {/* Type de publication */}
        <div className="flex items-center gap-3 p-4 bg-white/10 rounded-xl backdrop-blur-sm">
          <div className="w-10 h-10 rounded-full bg-[#D4AF37] flex items-center justify-center flex-shrink-0">
            {type === 'article' ? '📰' : type === 'video' ? '🎥' : '📢'}
          </div>
          <div>
            <div className="text-xs text-white/70 mb-1">Type</div>
            <div className="font-semibold">{typeLabels[type] || 'Article'}</div>
          </div>
        </div>

        {/* Titre */}
        <div className="p-4 bg-white/10 rounded-xl backdrop-blur-sm">
          <div className="text-xs text-white/70 mb-2">Titre</div>
          <div className="font-semibold line-clamp-2">{title}</div>
        </div>

        {/* Catégorie */}
        <div className="flex items-center justify-between p-4 bg-white/10 rounded-xl backdrop-blur-sm">
          <div>
            <div className="text-xs text-white/70 mb-1">Catégorie</div>
            <div className="font-semibold">{category}</div>
          </div>
          {imageCount && (
            <div className="px-3 py-1 bg-[#D4AF37] rounded-full text-sm font-bold">
              {imageCount} image{imageCount > 1 ? 's' : ''}
            </div>
          )}
        </div>

        {/* Durée */}
        <div className="p-4 bg-white/10 rounded-xl backdrop-blur-sm">
          <div className="text-xs text-white/70 mb-2">Durée de publication</div>
          <div className="flex items-center gap-2">
            <svg className="w-5 h-5 text-[#D4AF37]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <span className="font-bold text-lg">
              {duration} jour{duration > 1 ? 's' : ''}
            </span>
          </div>
        </div>

        {/* Ligne de séparation */}
        <div className="h-px bg-white/20 my-4"></div>

        {/* Total */}
        <div className="p-5 bg-gradient-to-r from-[#D4AF37] to-[#C49B2E] rounded-xl shadow-lg">
          <div className="flex items-center justify-between">
            <div>
              <div className="text-sm text-white/90 mb-1">Total à payer</div>
              <div className="text-3xl font-bold text-white">
                {price.toLocaleString('fr-FR')}
                <span className="text-lg ml-2">FCFA</span>
              </div>
            </div>
            <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center backdrop-blur-sm">
              <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
          </div>
        </div>

        {/* Info sécurité */}
        <div className="flex items-start gap-2 p-3 bg-white/5 rounded-lg">
          <svg className="w-5 h-5 text-green-400 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
          </svg>
          <div>
            <div className="text-xs font-semibold text-white mb-1">Paiement 100% sécurisé</div>
            <div className="text-xs text-white/70">Vos informations sont protégées</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OrderSummary
